export default __webpack_public_path__ + "static/media/KR_Hero1_1.2b7f9bd3.png";